import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magisnet',
  templateUrl: './magisnet.component.html',
  styleUrls: ['./magisnet.component.css']
})
export class MagisnetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
